export enum FarmType {
  LONG = "long",
  SHORT = "short",
}

export enum TradeType {
  BUY = "buy",
  SELL = "sell",
}

export enum MintType {
  BORROW = "borrow",
  SHORT = "short",
  EDIT = "edit",
  CLOSE = "close",
}

export enum PoolType {
  PROVIDE = "provide",
  WITHDRAW = "withdraw",
}

export enum StakeType {
  STAKE = "stake",
  UNSTAKE = "unstake",
}
